import rechargeIndex from '@/modules/recharge/recharges/store';
import subscriptionsIndex from '@/modules/recharge/subscriptions/store';
import stationIndex from '@/modules/recharge/stations/store';
import cashbackIndex from '@/modules/recharge/cashback/store';
import rechargesV2 from '@/modules/recharge/rechargesV2/store';

export default { modules: [rechargeIndex, subscriptionsIndex, stationIndex, cashbackIndex, rechargesV2] };
